var _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppleLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_318",
    "data-name": "Group 318",
    xmlns: "http://www.w3.org/2000/svg",
    width: 44.686,
    height: 44.686,
    viewBox: "0 0 44.686 44.686",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_63",
    "data-name": "Ellipse 63",
    cx: 22.343,
    cy: 22.343,
    r: 22.343,
    fill: "rgba(255,255,255,0.07)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_7935ec95c421cee6d86eb22ecd114eed",
    "data-name": "7935ec95c421cee6d86eb22ecd114eed",
    transform: "translate(11.52 9.726)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_391",
    "data-name": "Path 391",
    d: "M47.3,6.573a5.141,5.141,0,0,1,1.26-3.995A5.963,5.963,0,0,1,52.411.5a5.526,5.526,0,0,1-1.226,4.1A5.035,5.035,0,0,1,47.3,6.573Zm7.921,5.316a5.386,5.386,0,0,1,2.53-2.922,6.424,6.424,0,0,0-4.839-2.56c-2.275,0-3.237,1.084-4.817,1.084-1.628,0-2.863-1.084-4.833-1.084A6.583,6.583,0,0,0,37.968,9.6a7.245,7.245,0,0,0-.982,2.7,14.469,14.469,0,0,0,2.434,9.983c1.065,1.62,2.485,3.444,4.34,3.46,1.652.016,2.121-1.056,4.358-1.067s2.665,1.079,4.315,1.063c1.855-.016,3.353-2.035,4.419-3.654a18.281,18.281,0,0,0,1.635-3.063A5.608,5.608,0,0,1,55.221,11.889Z",
    transform: "translate(-36.84 -0.5)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleLogo);
export default __webpack_public_path__ + "static/media/appleLogo.06ac598ba6d9d78afe7184e95ea6920a.svg";
export { ForwardRef as ReactComponent };